import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報を取得するクラス
 *
 * @export GetGoodsBaseService
 * @class GetGoodsBaseService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetGoodsBaseService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private pCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsBaseService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsBaseService
   */
  execute(model: KYMW1100Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('getGoodsBase', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsBaseService
   */
  success(data: any): void {
    // 全項目を初期化する
    this.model.kymw1100Component.setWindowVisible('SEACH');

    this.model.updateGoodsBaseData(data);

    this.model.updateMarkCodeList(data);

    this.model.updateTextInfoList(data);

    this.model.updateListingList(data);
    // 商品DNA情報更新
    this.model.updateGoodsDnaList(data);
    // item情報
    this.model.updateGoodsDatailData(data);

    this.model.updateCheckGoodsCoopList(data);

    this.model.updateGoodsCoopWkList(data);

    this.model.updateSpecifications1List(data);

    this.model.updateGoodsAllergenList(data);

    this.model.updateGoodsNutrientInfo(data);

    this.model.updateGoodsEcologyList(data);

    this.model.updateGoodsGWStopList(data);

    this.model.updateContainPackingList(data);

    this.model.setTagInfo(data);

    this.model.setPublishMediumInfo(data);

    // 本登録かどうか判断するためにボタンの制御はupdateGoodsBaseData処理後にする。
    this.model.kymw1100Component.setSeachButton();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');

    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
